import { useState } from "react";

// Shows each button's title as an instant, styled caption under the toolbar icon.
export function HoverTips({ children, className = "", ...rest }) {
  const [tip, setTip] = useState(null);
  const over = (e) => {
    const hit = document.elementFromPoint(e.clientX, e.clientY);
    const el = hit && hit.closest("[title],[data-tip]");
    if (!el) { setTip(null); return; }
    if (!el || !e.currentTarget.contains(el)) return;
    if (el.title) { el.dataset.tip = el.title; el.removeAttribute("title"); }
    const box = e.currentTarget.getBoundingClientRect(), r = el.getBoundingClientRect();
    setTip({ text: el.dataset.tip, x: r.left - box.left + r.width / 2 });
  };
  return (
    <div {...rest} className={`relative ${className}`} onPointerMove={over} onMouseLeave={() => setTip(null)}>
      {children}
      {tip && (
        <span data-testid="toolbar-tooltip" style={{ left: tip.x }}
          className="pointer-events-none absolute top-full mt-1.5 -translate-x-1/2 z-[60] whitespace-nowrap rounded bg-slate-900 border border-slate-600 px-2 py-1 text-[11px] font-semibold text-white shadow-lg">
          {tip.text}
        </span>
      )}
    </div>
  );
}
